import { init } from './MallCPA12';
init();
